import { useContext, useCallback } from 'react'

import { Box } from '@material-ui/core'
import { faCalendar, faRepeat } from '@fortawesome/pro-solid-svg-icons'
import { faCalendar as farCalendar, faRepeat as farRepeat } from '@fortawesome/pro-regular-svg-icons'
import { SelectableIconChips } from '@scoir/college-search'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES, LABELS } from '../../components/constants'

const field = FIELD_NAMES.IS_RECURRING

const Recurrence = () => {
  const { item, onUpdateField, onUpdateFields, validation } = useContext(ContentModalContext)

  const value = item[field]

  const onSelect = useCallback(
    (recurring: boolean) => {
      onUpdateField(field, recurring)
      if (recurring) {
        // if recurring, time fields should be null
        onUpdateFields({
          [field]: recurring,
          [FIELD_NAMES.START_TIME]: null,
          [FIELD_NAMES.END_TIME]: null,
        })
        validation.clearErrors([LABELS.START_TIME, LABELS.END_TIME])
      } else {
        onUpdateField(field, recurring)
      }
    },
    [validation, onUpdateFields, onUpdateField],
  )

  return (
    <Box
      display="flex"
      gridGap={2}
      mb={1}
    >
      <SelectableIconChips
        gridItemProps={{ xs: 6 }}
        onSelect={onSelect}
        options={[
          {
            title: LABELS.HAPPENS_ONCE,
            faIcon: !value ? faCalendar : farCalendar,
            value: false,
            selected: !value,
          },
          {
            title: LABELS.RECURRING,
            faIcon: value ? faRepeat : farRepeat,
            value: true,
            selected: value,
          },
        ]}
      />
    </Box>
  )
}

export default Recurrence
